import { z } from "zod";

export const billingRedirect = z.object({
  redirect_url: z.string().nullable(),
});

export type BillingRedirect = z.infer<typeof billingRedirect>;
